import { ModuleRouter } from "@/components/module-router/module-router";

export function MasterdataRoutes() {
  return <ModuleRouter moduleId="masterdata" />;
}
